import { render } from "./ModalController.vue?vue&type=template&id=3293a12c"
import script from "./ModalController.vue?vue&type=script&lang=js"
export * from "./ModalController.vue?vue&type=script&lang=js"

import "./ModalController.vue?vue&type=style&index=0&id=3293a12c&lang=scss"

import exportComponent from "../../../../../SINTEZ/store/webadmin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__